import { Button } from '@/components/ui/button';
import { Eye } from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';
import { useVersion } from '@/hooks/useVersion';

export function VersionDetails() {
  const navigate = useNavigate();
  const { providerId, versionId } = useParams();
  const { data: version } = useVersion({ 
    providerId: Number(providerId), 
    versionId: Number(versionId) 
  });
  const isPublished = version?.status === 'published';

  if (!providerId || !versionId) {
    return <div>Invalid parameters</div>;
  }

  const handlePreview = () => {
    navigate(`/providers/${providerId}/versions/${versionId}/preview`);
  };

  return (
    <div className="space-y-4">
      {/* Version details content */}
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold">Version Details</h1>
        <Button
          variant="outline"
          onClick={handlePreview}
          disabled={!isPublished}
        >
          <Eye className="h-4 w-4 mr-2" />
          Preview Published Data
        </Button>
      </div>

      {/* Version information */}
      <div className="space-y-4">
        <div>
          <h2 className="text-lg font-semibold">Version Information</h2>
          <p className="text-sm text-muted-foreground">
            Status: {version?.status || 'Unknown'}
          </p>
          <p className="text-sm text-muted-foreground">
            Version Number: {version?.version_number || 'N/A'}
          </p>
          <p className="text-sm text-muted-foreground">
            Description: {version?.description || 'No description provided'}
          </p>
        </div>
      </div>
    </div>
  );
} 